const SkeletonCard = () => (
  <div className="rounded-[40px] overflow-hidden h-[550px] flex flex-col bg-gray-800/20 animate-pulse">
    {/* Top Image Area */}
    <div className="h-[65%] bg-gray-700/30" />
    
    {/* Bottom Content Area */}
    <div className="h-[35%] p-10 flex flex-col justify-between space-y-4">
      <div className="space-y-3">
        <div className="h-4 bg-gray-700/40 rounded w-full" />
        <div className="h-4 bg-gray-700/40 rounded w-5/6" />
      </div>
      <div className="h-3 bg-gray-700/50 rounded w-20" />
    </div>
  </div>
);

export default function NewsSkeleton() {
  return (
    <div className="bg-[#120428] py-20 px-6 md:px-16 text-white min-h-screen">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(3)].map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </div>
  );
}